import { useIntl } from 'react-intl';
import { mapHeadlineSize } from './helpers';

const Headline = ({ message, size = 24 }) => {
  const { formatMessage } = useIntl();
  const classNames = `integration__headline ${mapHeadlineSize[size]}`;

  return message && <h3 className={classNames}>{formatMessage({ id: message })}</h3>;
};

export default Headline;
